import React, { FC } from 'react';
import Modal from './common/Modal/Modal';
import { useAppDispatch } from '../hooks';
import { setTxHasError, setTxIsOngoing } from '../redux/slices/bridgeSlice';
import useExchangeInit from '../hooks/useExchangeInit';
import useNotification from '../hooks/useNotification';

interface Error {
  code: number;
  message: string;
  stack: string;
}

interface ModalExchangeAgreementProps {
  isShow: boolean;
  onRequestClose: () => void;
}

const ModalExchangeAgreement: FC<ModalExchangeAgreementProps> = ({
  isShow,
  onRequestClose,
}) => {
  const dispatch = useAppDispatch();
  const exchangeInit = useExchangeInit();
  const notificationAction = useNotification();

  const handleSendTransaction = React.useCallback(async () => {
    dispatch(setTxIsOngoing(true));
    try {
      await exchangeInit();
    } catch (e) {
      console.error(e);
      dispatch(setTxHasError(true));
    }
  }, [dispatch, exchangeInit]);

  const agreementConfirm = React.useCallback(() => {
    if (!(`Notification` in window)) {
      console.error(`Notification is not supported.`);
    } else if (Notification.permission !== `denied`) {
      Notification.requestPermission((permission) => {
        if (permission === `granted`) {
          notificationAction(`Bridge has started Converting`);
        }
      });
    }
    handleSendTransaction();
    onRequestClose();
  }, [handleSendTransaction, notificationAction, onRequestClose]);

  return (
    <Modal
      isShow={isShow}
      onClose={onRequestClose}
      title="Agree to provide desktop notifications."
      explanation={
        <>
          <br />
          Changes in settings are required to provide notification of progress.
          Please click the <strong>OK</strong> button to use the notification.
        </>
      }
      footerComponent={
        <button
          onClick={agreementConfirm}
          className="btn btn-block btn-primary btn-lg"
        >
          OK
        </button>
      }
    >
      <div data-caution="info">
        <i data-icon="info" />
        If it is not set, manually set it by entering the
        <code> [More] - [Settings]</code> menu at the top of the chrome.
      </div>
    </Modal>
  );
};

export default ModalExchangeAgreement;
